import { render, staticRenderFns } from "./ProductCreateFormWizard.vue?vue&type=template&id=2299e1bf&"
import script from "./ProductCreateFormWizard.vue?vue&type=script&lang=ts&"
export * from "./ProductCreateFormWizard.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCreateFormWizard.vue?vue&type=style&index=0&id=2299e1bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports